import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

export const adminPullRequestQueryKey = (orgId: string, pullId: string) =>
  ["admin", "org", orgId, "pull-requests", pullId] as const;

export function useAdminPullRequest(orgId: string, pullId: string) {
  return useQuery({
    queryKey: adminPullRequestQueryKey(orgId, pullId),
    queryFn: () =>
      api
        .get<"/admin/:orgId/pull-requests/:pullId">(
          `/admin/${orgId}/pull-requests/${pullId}`,
        )
        .then((res) => res.data),
  });
}
